module.exports = __webpack_public_path__ + "static/img/loading.d6ac13d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/loading.gif
// module id = afRe
// module chunks = 0